import React, { useState } from 'react';
import { Box, Button, Text } from '@chakra-ui/core';
import { apiV1 } from '../api/api';

const DEFAULT_ERROR = 'Le téléchargement a échoué. Vous pouvez réessayer.';

const downloadArchive = async (folderId, kind, fallbackName) => {
  const response = await apiV1.get(`/folders/${folderId}/document_archives/${kind}`, {
    responseType: 'blob',
  });
  const disposition = response.headers?.['content-disposition'] || '';
  const filename = (disposition.match(/filename="?([^";]+)"?/) || [])[1] || fallbackName;
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// The API answers with a blob even for errors: read it back to show the reason given by the server.
const archiveErrorMessage = async failure => {
  try {
    const body = failure?.response?.data;
    const text = body && typeof body.text === 'function' ? await body.text() : null;
    const messages = text ? JSON.parse(text)?.errors?.archive : body?.errors?.archive;
    return Array.isArray(messages) && messages.length ? messages.join(' ') : DEFAULT_ERROR;
  } catch {
    return DEFAULT_ERROR;
  }
};

export const DocumentArchiveButton = ({ folderId, kind, label, isDisabled, hint, ...props }) => {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(null);

  const download = async () => {
    setPending(true);
    setError(null);
    try {
      await downloadArchive(folderId, kind, `${kind}.zip`);
    } catch (failure) {
      setError(await archiveErrorMessage(failure));
    } finally {
      setPending(false);
    }
  };

  return (
    <Box {...props}>
      <Button
        type="button"
        variant="outline"
        variantColor={null}
        borderColor="semiDarkGray.900"
        color="semiDarkGray.900"
        onClick={download}
        isLoading={pending}
        loadingText="Préparation…"
        isDisabled={isDisabled}
        whiteSpace="normal"
        height="auto"
        py={2}
      >
        {label}
      </Button>
      {hint && (
        <Text mt={2} fontSize="sm" color="semiDarkGray.600">
          {hint}
        </Text>
      )}
      {error && (
        <Text role="alert" mt={2} color="coral.700" fontSize="sm">
          {error}
        </Text>
      )}
    </Box>
  );
};

export default DocumentArchiveButton;
